export default "__VITE_ASSET__2J7zuxd5__"